<template>
  <div class="coupon">
    <div class="title">
      <p>券列表</p>
    </div>
    <div class="main">
      <div class="souS">
        <el-row :gutter="20" class="searchRow" type="flex" align="middle">
          <el-col :span="4">
            <el-select v-model="queryform.used" placeholder="类型一筛选" style="width: 100%;">
              <el-option v-for="item in GLOBALState.typeOneFiltering" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select v-model="queryform.type" placeholder="类型二筛选" style="width: 100%;">
              <el-option v-for="item in GLOBALState.typeTowFiltering" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input v-model="queryform.secret" clearable placeholder="批次号"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input v-model="queryform.memo" clearable placeholder="券备注"></el-input>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="handleButton(1)">搜 索</el-button>
            <el-button type="primary" @click="handleButton(2)">重 置</el-button>
            <el-button type="warning" @click="genStamps()" icon="el-icon-plus">创 券</el-button>
          </el-col>
        </el-row>
      </div>

      <div class="table-content">
        <el-table :data="list" border ref="multipleTable" v-loading="listLoading" style="width: 100%" :header-cell-style="headClass" :cell-style="rowClass">
          <el-table-column prop="batchNo" label="批次号" />
          <el-table-column prop="memo" label="券备注" />
          <el-table-column prop="title" label="显示名称" />
          <el-table-column prop="typeOne" label="类型一" />
          <el-table-column prop="typeTwo" label="类型二" />
          <el-table-column label="券面额" width="120">
            <template slot-scope="scope">
              <div :style="{ color: '#FF981B' }" v-if="scope.row.typeTwo != '折扣'">{{ scope.row.couponAmount }}</div>
              <div :style="{ color: '#FF981B' }" v-if="scope.row.typeTwo == '折扣' && scope.row.couponAmount != null">
                {{ scope.row.couponAmount.substring(0, scope.row.couponAmount.length - 4) }}%
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="validType" label="有效类型" />
          <el-table-column prop="validDay" label="有效日期" width="140" />
          <el-table-column prop="quota" label="创建数量" />
          <el-table-column prop="remain" label="剩余数量" />
          <el-table-column prop="everyCount" label="每人限额" />
          <el-table-column prop="inGoods" label="商品显示" />
          <el-table-column prop="inActivity" label="券中心显示" width="100" />
          <el-table-column prop="bondGoods" label="绑定商品数" width="100" />
          <el-table-column prop="secret" label="批次密钥" />
          <el-table-column prop="createdAt" label="创建日期" width="200" />
          <el-table-column label="审核状态" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.checkStatus == '待审核'" :style="{ color: '#23CA18' }">待审核</div>
              <el-link v-if="scope.row.checkStatus == '已通过'" :style="{ color: '#2394FE' }" @click="sjx(scope.row.id, 1)">已通过</el-link>
              <el-link v-if="scope.row.checkStatus == '已拒绝'" :style="{ color: '#F60A0A' }" @click="sjx(scope.row.id, 2)">已拒绝</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="confirm" label="确认函" width="100">
            <template slot-scope="scope">
              <i class="el-icon-paperclip"></i>
              <el-button type="text" :style="{ color: '#5A5A5A ' }" @click="xz(scope.row.confirm)">附件</el-button>
            </template>
          </el-table-column>
          <el-table-column label="券批次状态" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.batchStatus == '待审'" :style="{ color: '#23CA18' }">待审</div>
              <div v-if="scope.row.batchStatus == '正常'" :style="{ color: '#2394FE' }">正常</div>
              <div v-if="scope.row.batchStatus == '失效'" :style="{ color: '#F60A0A' }">失效</div>
              <div v-if="scope.row.batchStatus == '停用'" :style="{ color: '#FF981B' }">停用</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="170" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" round @click="det(scope.row)">查看详情</el-button>
              <el-button type="text" size="mini" :style="{ color: '#FF981B' }" v-if="scope.row.batchStatus == '停用'" @click="enableDisable(1, scope.row.id)">启用</el-button>
              <el-button type="text" size="mini" :style="{ color: '#F60A0A' }" v-if="scope.row.batchStatus == '正常'" @click="enableDisable(2, scope.row.id)">停用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <pagination v-if="list.length > 0" :total="total" :pageNum="queryform.page" :pageSize="queryform.pageSize" @pageChange="pageChange" />
      <Det :show="showDet" :dets="dets" :title="title" @close="close" />
      <ShowgenStamps :show="showgenStamps" @close="close" />
      <el-dialog :title="titlesjx" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <div class="left-lineBox">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in activities" :key="index" :color="colors">
              <p class="timeline-name" v-if="index == 0">申请 {{ item.timestamp }}</p>
              <p class="timeline-name" v-if="index == 1">审核 {{ item.timestamp }}</p>
              <p class="timeline-name" v-if="index == 2 && item.timestamp != ''">已通过 {{ item.timestamp }}</p>
              <p class="timeline-name" v-if="index == 3 && item.timestamp != ''">已拒绝 {{ item.timestamp }}</p>
              <p class="timeline-content" v-if="index == 0">
                <span>公司/个人:</span>
                <span>{{ item.content }}</span>
              </p>
              <p class="timeline-content" v-if="index == 0">
                <span>店铺名称:</span>
                <span>{{ item.content1 }}</span>
              </p>
              <p class="timeline-content" v-if="index == 1">
                <span>审核人账号:</span>
                <span>{{ item.content }}</span>
              </p>
              <p class="timeline-content" v-if="index == 1">
                <span>审核人姓名:</span>
                <span>{{ item.content1 }}</span>
              </p>
              <p class="timeline-content" v-if="index == 2 && item.timestamp != ''">
                <span>审核备注:</span>
                <span>{{ item.content }}</span>
              </p>
              <p class="timeline-content" v-if="index == 3 && item.timestamp != ''">
                <span>拒绝原因:</span>
                <span>{{ item.content }}</span>
              </p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import pagination from "@/components/pagination/index.vue";
import Det from "./common/couponSettingdet";
import ShowgenStamps from "./common/couponSettingsS";
import { couponAll, couponEnable, couponDisable, couponCheckInfo } from "@/api/couponManagement/couponSetting";
export default {
  components: {
    pagination,
    Det,
    ShowgenStamps
  },
  data() {
    return {
      queryform: {
        used: "",
        type: "",
        secret: "",
        memo: "",
        diffPage: 4,
        pageSize: 10,
        page: 1
      },
      listLoading: false,
      total: 0,
      list: [],
      showDet: false, //详情
      dets: "", //详情
      title: "", // 详情
      showgenStamps: false, //创券
      activities: [],
      titlesjx: "",
      dialogVisible: false // 时间线的dialog
    };
  },
  created() {
    this.postcouponAll();
  },
  methods: {
    rowClass() {
      return "text-align:center";
    }, //表格数据居中显示
    headClass() {
      return "text-align:center";
    }, //表头居中显示
    handleButton(val) {
      switch (val) {
        case 1:
          this.postcouponAll();
          break;
        case 2:
          Object.assign(this.$data, this.$options.data());
          this.postcouponAll();
          break;
        default:
          break;
      }
    },
    close() {
      this.showDet = false; //详情
      this.showgenStamps = false; //创券
      this.postcouponAll();
    },
    pageChange(page) {
      this.queryform.pageSize = page._pageSize;
      this.queryform.page = page._currentPage;
      this.postcouponAll();
    },
    // 停用启用
    enableDisable(val, id) {
      let val1 = "";
      if (val == 1) {
        val1 = "启用";
      } else {
        val1 = "停用";
      }
      this.$prompt("", val1, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "不能为空",
        inputPlaceholder: "请输入" + val1 + "原因"
      })
        .then(value => {
          if (val == 1) {
            let data = {
              id: id,
              reason: value.value
            };
            couponEnable(data).then(res => {
              this.postcouponAll();
            });
          } else {
            let data = {
              id: id,
              reason: value.value
            };
            couponDisable(data).then(res => {
              this.postcouponAll();
            });
          }
          this.$message({
            type: "success",
            message: val1 + "成功"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消" + val1
          });
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 详情
    det(row) {
      this.showDet = true;
      this.title = "优惠券设置";
      this.dets = row;
    },
    // 创券
    genStamps() {
      this.showgenStamps = true;
      console.log();
    },
    closeStore() {
      console.log(2);
      this.showStore = false; //关联店铺
    },
    // 获取列表
    postcouponAll() {
      let data = this.queryform;
      couponAll(data).then(res => {
        this.list = res.result.records;
        this.total = parseInt(res.result.total);
        console.log(this.list, "res----------------------");
      });
    },
    // 时间线
    sjx(row, sjxs) {
      if (sjxs == 1) {
        this.titlesjx = "已通过";
      } else {
        this.titlesjx = "已拒绝";
      }
      this.dialogVisible = true;
      couponCheckInfo(row).then(res => {
        this.activities = res.data.result;
      });
    },
    // 下载
    xz(row) {
      if (row != null) {
        let href = row;
        window.open(href, "_blank");
      } else {
        this.$message("未上传附件");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.coupon {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    padding: 15px 32px;
    display: flex;
    align-items: center;
    p {
      font-size: 18px;
      color: #333;
      margin-left: 0;
    }
  }

  & > .main {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    background: #fff;
    margin: 24px;
    padding: 30px;
    padding-bottom: 70px;
    min-height: 700px;
    min-width: 1200px;
  }
  .pageSize {
    margin-top: 40px;
    text-align: right;
  }
}
.souS {
  margin-bottom: 20px;
}
</style>
